<template>
    <BaseAd>
        <template #title>
            {{ $t('configuratorDedicated.specialDealsAdTitle') }}
        </template>

        <!-- eslint-disable vue/no-v-html -->
        <span
            v-html="
                $t('configuratorDedicated.specialDealsAdDescription', {
                    href: '/dedicated-server-mieten',
                })
            "
        ></span>
    </BaseAd>
    <!-- eslint-enable vue/no-v-html -->
</template>
